import { useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateWorkItem } from 'queries';

import { Button } from 'common/button';

import TaskActivityNotesModal from './task-activity-notes-modal';
const useStyles = makeStyles(() => ({
  container: { paddingBottom: 10 },
  stackedDataFirst: {
    display: 'block',
    lineHeight: '1.43',
    width: '100%',
  },
  stackedData: {
    display: 'block',
    lineHeight: '1.43',
    paddingTop: 5,
  },
}));

type EstateWorkItemTaskCellProps = {
  estateWorkItem: EstateWorkItem;
};

const EstateWorkItemTaskCell = ({ estateWorkItem }: EstateWorkItemTaskCellProps) => {
  const classes = useStyles();
  const [activeTaskActivityNoteEstateWorkItem, setActiveTaskActivityNoteEstateWorkItem] =
    useState<EstateWorkItem>();
  const payment = estateWorkItem.estatePayment;

  let paymentNotes = 'N/A';
  let paymentQuantity = 1;
  if (payment) {
    paymentNotes = payment.notes || 'N/A';
    paymentQuantity = payment.quantity || 1;
  }

  return (
    <div className={classes.container}>
      <br />
      {estateWorkItem.workText}
      <div className={classes.stackedDataFirst}>
        <Typography variant="caption">Notes: {paymentNotes}</Typography>
      </div>
      <div className={classes.stackedDataFirst}>
        <Typography variant="caption">Quantity: {paymentQuantity}</Typography>
      </div>
      <div className={classes.stackedData}>
        <Button
          onClick={() => {
            setActiveTaskActivityNoteEstateWorkItem(estateWorkItem);
          }}
          size="tiny"
        >
          activity
        </Button>
      </div>
      {activeTaskActivityNoteEstateWorkItem && (
        <TaskActivityNotesModal
          estateWorkItem={activeTaskActivityNoteEstateWorkItem}
          onClose={() => setActiveTaskActivityNoteEstateWorkItem(undefined)}
        />
      )}
    </div>
  );
};

export default EstateWorkItemTaskCell;
